import React, {useEffect, useState} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import './ProgressBar.css';
import Divider from '@material-ui/core/Divider'

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 40,
        borderRadius: 40,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 40,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    title: {
      alignSelf: "center",
    },
});
export default function CustomizedProgressBars(props)
{
    const classes = useStyles();
    const [ratioAlphaOfDeltaM1, setRatioAlphaOfDeltaM1] = useState(0);
    const [ratioBetaOfThetaM1, setRatioBetaOfThetaM1] = useState(0);
    const [ratioAlphaOfDeltaM2, setRatioAlphaOfDeltaM2] = useState(0);
    const [ratioBetaOfThetaM2, setRatioBetaOfThetaM2] = useState(0);

    const [museInterval, setMuseInterval] = useState(undefined);

    useEffect(async() => {

        if (museInterval !== undefined)
        {
            await setMuseInterval(clearInterval(museInterval));
        }

        if (props.muse1 === undefined)
        {
            setRatioAlphaOfDeltaM1(0);
            setRatioBetaOfThetaM1(0);
        }

        if (props.muse2 === undefined)
        {
            setRatioAlphaOfDeltaM2(0);
            setRatioBetaOfThetaM2(0);
        }

        setMuseInterval(setInterval(setAll, 100))

    }, [props.muse1, props.muse2])


    function setAll()
    {
        if (props.muse1 !== undefined)
        {
            setRatioAlphaOfDeltaM1(props.muse1.getRatioAlphaOfDelta());
            setRatioBetaOfThetaM1(props.muse1.getRatioBetaOfTheta());
        }

        if (props.muse2 !== undefined)
        {
            setRatioAlphaOfDeltaM2(props.muse2.getRatioAlphaOfDelta());
            setRatioBetaOfThetaM2(props.muse2.getRatioBetaOfTheta());
        }

    }

    return (
        <div className="Container">
            <br />
            <div className={classes.root}>
                <h3 className={classes.title}>Bandeau 1</h3>
                <p>α/Δ {(ratioAlphaOfDeltaM1*100).toFixed(5)}</p>
                <BorderLinearProgress className="progressBar" variant="determinate" value={ratioAlphaOfDeltaM1*10} />
                <p>β/θ {(ratioBetaOfThetaM1*100).toFixed(5)}</p>
                <BorderLinearProgress className="progressBar" variant="determinate" value={ratioBetaOfThetaM1*10} />
            </div>
            <Divider orientation="vertical"/>
            <div className={classes.root}>
                <h3 className={classes.title}>Bandeau 2</h3>
                <p>α/Δ {(ratioAlphaOfDeltaM2*100).toFixed(5)}</p>
                <BorderLinearProgress className="progressBar" variant="determinate" value={ratioAlphaOfDeltaM2*10} />
                <p>β/θ {(ratioBetaOfThetaM2*100).toFixed(5)}</p>
                <BorderLinearProgress className="progressBar" variant="determinate" value={ratioBetaOfThetaM2*10} />
            </div>
        </div>
    );
}
